/** Shared filter/search toolbar layout tokens. */
import { IPD_COLORS, IPD_SHAPE } from "./ipdColors";

export const FILTER_TOOLBAR = {
  gap: 2,
  mb: 2,
  searchMin: 240,
  searchMax: 360,
  filterWidth: 160,
  filterWidthWide: 180,
  controlHeight: 40,
};

export const toolbarSx = {
  display: 'flex',
  alignItems: 'flex-end',
  gap: FILTER_TOOLBAR.gap,
  flexWrap: 'wrap',
};

export const filterToggleSx = {
  backgroundColor: IPD_COLORS.toggleTrackBg,
  borderRadius: `${IPD_SHAPE.radiusLg}px`,
  p: '3px',
  gap: 0,
  '& .MuiToggleButtonGroup-grouped': {
    border: 'none',
    borderRadius: `${IPD_SHAPE.radiusMd}px !important`,
    mx: 0,
  },
  '& .MuiToggleButton-root': {
    color: IPD_COLORS.textSecondary,
    textTransform: 'none',
    fontWeight: 500,
    fontSize: 13,
    px: 2,
    py: 0.6,
    border: 'none',
    '&.Mui-selected': {
      color: IPD_COLORS.primary,
      backgroundColor: IPD_COLORS.cardBg,
      fontWeight: 600,
      boxShadow: IPD_COLORS.shadow.card,
    },
    '&:hover': { backgroundColor: 'rgba(255,255,255,0.6)' },
  },
};
